<template>
  <v-form ref="form" flat class="pt-5">
    <AutocompleteAcademicLevel
      v-model="academicLevel"
      clear-icon="mdi-close"
      item-text="title"
      item-value="id"
      label="Bộ môn"
      clearable
      outlined
      dense
      hide-details
      return-object
      class="required mb-6"
      :rules="[$rules.required]"
    />
    <AutocompleteSelectDivision
      class="required"
      v-model="division"
      item-text="title"
      item-value="id"
      label="Chương trình đào tạo"
      required
      dense
      outlined
      auto-select-first
      :title="get(academicLevel, 'title', '')"
      :filter="{ academicLevel: get(academicLevel, 'id', '') }"
      :rules="[$rules.required]"
    />
    <v-text-field
      label="Mã học phần"
      v-model="code"
      dense
      outlined
      class="required"
      :rules="[$rules.required]"
    ></v-text-field>
    <v-text-field label="Tên học phần mới" v-model="title" dense outlined class="required" :rules="[$rules.required]">
    </v-text-field>
    <v-text-field
      label="Tổng số buổi"
      v-model="totalDate"
      dense
      outlined
      class="required"
      :rules="[$rules.required, $rules.isNumber]"
    ></v-text-field>

    <v-textarea
      ref="description"
      v-model="description"
      label="Ghi chú"
      outlined
      dense
      rows="3"
      hide-details
    ></v-textarea>
  </v-form>
</template>
<script>
import { mapState } from 'vuex'
import get from 'lodash-es/get'
import AutocompleteDivision from '../input/AutocompleteDivision.vue'
import AutocompleteAcademicLevel from '../input/AutocompleteAcademicLevel.vue'
import AutocompleteSelectDivision from '../../../modules/grade/AutocompleteSelectDivision.vue'
export default {
  components: {
    AutocompleteDivision,
    AutocompleteAcademicLevel,
    AutocompleteSelectDivision
  },
  computed: {
    ...mapState({
      academicLevels(state) {
        return state['AcademicLevel'].academics
      }
    })
  },
  data: () => ({
    valid: true,
    academicLevel: {},
    description: '',
    title: '',
    code: '',
    division: '',
    totalDate: null,
    get
  }),
  props: {
    grade: { type: Object, default: () => {} },
    editCode: { type: Boolean, default: false }
  },
  methods: {
    reset() {
      this.$refs.form.reset()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    validate() {
      return this.$refs.form.validate()
    },
    getData() {
      return {
        title: this.title,
        code: this.code,
        description: this.description,
        academicLevel: get(this.academicLevel, 'id'),
        totalDate: this.totalDate,
        division: this.division
      }
    },
    resetDefault() {
      if (this.grade) {
        this.title = this.grade.title
        this.code = this.grade.code
        this.description = this.grade.description
        this.academicLevel = this.grade.academicLevel
        this.totalDate = this.grade.totalDate
        this.division = this.grade.division
      } else {
        this.title = ''
        this.description = ''
        this.code = ''
        this.academicLevel = {}
        this.totalDate = null
      }
    }
  },
  created() {
    this.resetDefault()
  },
  watch: {
    grade() {
      this.resetDefault()
    }
  }
}
</script>
